import { ICauHinhXeBusSaveRequest } from '../../../models/request/bus/cauHinhXeBusSaveRequest';
import { dm_cauhinhxebus } from '../../../models/response/bus/dm_cauhinhxebus';

export enum eCauHinhXeBusActionTypeIds {
	LOAD_START = "CAU_HINH_XE_BUS_LOAD_START",
	LOAD_SUCCESS = "CAU_HINH_XE_BUS_LOAD_SUCCESS",
	LOAD_ERROR = "CAU_HINH_XE_BUS_LOAD_ERROR",

	SHOW_DETAIL = "CAU_HINH_XE_BUS_SHOW_DETAIL",
	CLOSE_DETAIL = "CAU_HINH_XE_BUS_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "CAU_HINH_XE_BUS_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "CAU_HINH_XE_BUS_SHOW_CONFIRM",
	CLOSE_CONFIRM = "CAU_HINH_XE_BUS_CLOSE_CONFIRM",

	DELETE_START = "CAU_HINH_XE_BUS_DELETE_START",
	DELETE_SUCCESS = "CAU_HINH_XE_BUS_DELETE_SUCCESS",
	DELETE_ERROR = "CAU_HINH_XE_BUS_DELETE_ERROR",

	SAVE_START = "CAU_HINH_XE_BUS_SAVE_START",
	SAVE_SUCCESS = "CAU_HINH_XE_BUS_SAVE_SUCCESS",
	SAVE_ERR = "CAU_HINH_XE_BUS_SAVE_ERR"
}

export interface ICauHinhXeBusLoadStart {
	type: eCauHinhXeBusActionTypeIds.LOAD_START,
	payload: number
}
export interface ICauHinhXeBusLoadSuccess {
	type: eCauHinhXeBusActionTypeIds.LOAD_SUCCESS,
	payload: dm_cauhinhxebus[]
}
export interface ICauHinhXeBusLoadErr {
	type: eCauHinhXeBusActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface ICauHinhXeBusShowDetail {
	type: eCauHinhXeBusActionTypeIds.SHOW_DETAIL,
	payload?: dm_cauhinhxebus
}
export interface ICauHinhXeBusCloseDetail {
	type: eCauHinhXeBusActionTypeIds.CLOSE_DETAIL
}
export interface ICauHinhXeBusChangeSelectedIds {
	type: eCauHinhXeBusActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface ICauHinhXeBusShowConfirm {
	type: eCauHinhXeBusActionTypeIds.SHOW_CONFIRM
}
export interface ICauHinhXeBusCloseConfirm {
	type: eCauHinhXeBusActionTypeIds.CLOSE_CONFIRM
}
export interface ICauHinhXeBusDeleteStart {
	type: eCauHinhXeBusActionTypeIds.DELETE_START,
	payload: number
}
export interface ICauHinhXeBusDeleteSuccess {
	type: eCauHinhXeBusActionTypeIds.DELETE_SUCCESS
}
export interface ICauHinhXeBusDeleteErr {
	type: eCauHinhXeBusActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface ICauHinhXeBusSaveStart {
	type: eCauHinhXeBusActionTypeIds.SAVE_START,
	payload: ICauHinhXeBusSaveRequest
}
export interface ICauHinhXeBusSaveSuccess {
	type: eCauHinhXeBusActionTypeIds.SAVE_SUCCESS
}
export interface ICauHinhXeBusSaveErr {
	type: eCauHinhXeBusActionTypeIds.SAVE_ERR,
	payload: string
}
export type ICauHinhXeBusActionTypes = ICauHinhXeBusLoadStart | ICauHinhXeBusLoadSuccess | ICauHinhXeBusLoadErr |
	ICauHinhXeBusShowDetail | ICauHinhXeBusCloseDetail |
	ICauHinhXeBusChangeSelectedIds |
	ICauHinhXeBusShowConfirm | ICauHinhXeBusCloseConfirm |
	ICauHinhXeBusDeleteStart | ICauHinhXeBusDeleteSuccess | ICauHinhXeBusDeleteErr |
	ICauHinhXeBusSaveStart | ICauHinhXeBusSaveSuccess | ICauHinhXeBusSaveErr
